import React from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { Icon, Typography, Grid, Card, CardActionArea, CardContent, CardMedia,
		 Button, GridList, GridListTile } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';

//services
import BannerAPI from '../../../services/api/Banner';
import EventoAPI from '../../../services/api/Evento';
import LojaAPI from '../../../services/api/Loja';
import CinemaAPI from '../../../services/api/Cinema';

const ButtonNext = (props) => {
	const { onClick } = props;
	return (
	  <div className="arrow_carousel slick-next" onClick={onClick}>
		  <Icon>chevron_right</Icon>
	  </div>
	);
}

const ButtonPrev = (props) => {
	const { onClick } = props;
	return (
	<div className="arrow_carousel slick-prev" onClick={onClick}>
		<Icon>chevron_left</Icon>
	</div>
	);
}

//css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './inicio.css';

export default class Inicio extends React.Component {
	state = {
		banners:[],
		eventos:[],
		lojas: [],
		filmes: [],
		servicos: [],

		load_banners: true,
		load_eventos: true,
		load_lojas: true,
		load_filmes: true,
		load_servicos: true,
	}

	refreshBanners = () => {
		BannerAPI.lista_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ banners: res, load_banners: false })
				return;
			})
		});
	}

	refreshFilmes = () => {
		CinemaAPI.lista()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ filmes: res, load_filmes: false })
				return;
			})
		});
	}

	refreshEventos = () => {
		EventoAPI.lista_prev_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ eventos: res, load_eventos: false })
				return;
			})
		});
	}

	refreshLojas = () => {
		LojaAPI.lista_destaques_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ lojas: res, load_lojas: false })
				return;
			})
		});
	}

	refreshLojasServicos = () => {
		LojaAPI.lista_servicos_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ servicos: res, load_servicos: false })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshBanners(
			this.refreshEventos(
				this.refreshLojas(
					this.refreshFilmes(
						this.refreshLojasServicos()
					)
				)
			)
		);
	}
    render() {
		const { banners, eventos, lojas, filmes, load_banners, load_eventos, load_lojas, load_filmes, load_servicos,
				servicos } = this.state;
		const { informacoes } = this.props;
		const setting_slider = {
			dots: false,
			autoplay: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			nextArrow: <ButtonNext />,
      		prevArrow: <ButtonPrev />
		  };
		const settings_cinema = {
			dots: true,
			infinite: filmes.length > 5,
			autoplay:true,
			padding:'30px',
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 1,
			nextArrow: <ButtonNext />,
			prevArrow: <ButtonPrev />,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: filmes.length > 3,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		  };
		const settings_servicos = {
			dots: true,
			infinite: servicos.length > 4,
			autoplay: true,
			padding:'0px',
			speed: 500,
			slidesToShow: 4,
			slidesToScroll: 1,
			nextArrow: <ButtonNext />,
			prevArrow: <ButtonPrev />,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: servicos.length > 3,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		  };
        return (
				<div>
					<Helmet>
						<title>Inicio</title>
						<meta name="description" content={informacoes.meta_descricao} />
					</Helmet>
					<section className="slider_principal" >
						<LoadBox loading={load_banners} height="40vh" >
							<Slider {...setting_slider}>
								{banners.map((b,k) => <div key={k} >
										<a target="_BLANK" href={b.link} ><img className="img_slider" src={b.img} alt="" /></a>
								</div>)}
							</Slider>
						</LoadBox>
					</section>
					{!!eventos.length && <section className="section_content section_eventos" >
						<div className="section_content__title" >
							<Typography variant="h4" gutterBottom>
								FIQUE POR DENTRO
							</Typography>
							<Typography variant="subtitle1" gutterBottom>
								Confira os eventos do <b>Shopping Norte Sul</b>
							</Typography>
						</div>
						<div className="seciont_content__items" >
							<LoadBox loading={load_eventos} height="30vh" >
								<Grid container spacing={32} >
									{eventos.map((e,k) => <Grid key={k} item xs={12} md={4} >
										<Card className="card_transparent" >
											<CardActionArea component={Link} to={`eventos/${e.id}`} >
												<CardMedia
													className="media"
													image={e.img}
													title={e.titulo}
												/>
												<CardContent className="content" >
													<Typography gutterBottom variant="h5" component="h2">
														{e.titulo}
													</Typography>
													<Typography variant="body2" color="textSecondary" component="p">
														{e.descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}
													</Typography>
												</CardContent>
											</CardActionArea>
										</Card>
									</Grid>)}
									<Grid item xs={12} >
										<Button component={Link} to="eventos" variant="outlined" size="large" className="button_section" color="default">
											Veja todos os eventos
										</Button>
									</Grid>
								</Grid>
							</LoadBox>
						</div>
					</section>}
					<section className="section_content" >
						<div className="section_content__title" >
							<Typography variant="h4" gutterBottom>
								NOSSAS LOJAS
							</Typography>
						</div>
						<div className="seciont_content__items" >
							<LoadBox loading={load_lojas} height="30vh" >
								<Grid container spacing={32} >
									<Grid item xs={12} >
										<GridList cellHeight={270} cols={3} className="list_lojas" >
											{lojas.map((l,k) => <GridListTile className="tile" key={k} cols={1}>
												<img src={l.img} alt={l.nome} />
												<Link to={`lojas/${l.id}`} >
													<div className="grid_lojas__item" >
														<p>
															<span>{l.nome}</span>
															<small>{l.piso}º Piso</small>
														</p>
													</div>
												</Link>
											</GridListTile>)}
										</GridList>
									</Grid>
									<Grid item xs={12} >
										<Button component={Link} to="lojas" variant="outlined" size="large" className="button_section" color="default">
											VEJA TODAS AS LOJAS
										</Button>
									</Grid>
								</Grid>
							</LoadBox>
						</div>
					</section>
					<section className="section_content section_servicos" >
						<div className="section_content__title" >
							<Typography variant="h4" gutterBottom>
								SERVIÇOS
							</Typography>
						</div>
						<div className="seciont_content__items" >
							<LoadBox loading={load_servicos} height="30vh" >
								<Grid container spacing={16} >
									<Grid item xs={12} >
										<Slider {...settings_servicos}>
											{servicos.map((f,k) => <Link to={`lojas/${f.id}`} key={k} ><div className="item_servico" >
												<img className="img_slider" src={f.img} alt={f.titulo} />
												<Typography variant="h6" className="title_slider" gutterBottom>
													{f.nome}
												</Typography>
												<Typography variant="body2">{f.piso}º Piso</Typography>
											</div></Link>)}
										</Slider>
									</Grid>
								</Grid>
							</LoadBox>
						</div>
					</section>
					<section className="section_content section_cinema" >
						<div className="section_content__title" >
							<Typography variant="h4" gutterBottom>
								CINEMA
							</Typography>
							<Typography variant="subtitle1" gutterBottom>
								Próximas Sessões
							</Typography>
						</div>
						<div className="seciont_content__items" >
							<LoadBox loading={load_filmes} height="30vh" >
								<Grid container spacing={16} >
									<Grid item xs={12} >
										<Slider {...settings_cinema}>
											{filmes.map((f,k) => <Link  to={`cinema/filme/${f.IDFILME}`} key={k} ><div className="item_cinema" >
												<img className="img_slider" src={f.IMAGENS[0].URL} alt={f.IMAGENS[0].URL} />
												<Typography variant="h6" className="title_slider" gutterBottom>
													{f.TITULO}
												</Typography>
											</div></Link>)}
										</Slider>
									</Grid>
								</Grid>
							</LoadBox>
						</div>
					</section>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/inicio/index.js